module.exports = __webpack_public_path__ + "assets/img/1e0752c7a257a7224de9f787be261a7b.svg";